<template>
<div @click.capture="checkLoginGbn">
  <div>
      <base-header  pageName="Waple" :prevBtnShow="false" :srvySqno="srvySqno" :main="true"></base-header>

      <section id="wrap" class="mainWrap" ref="body">
          <div class="profile">
              <span class="" v-text="orgnzPstnGradeNm"></span>
              <strong v-html="'<b>'+userName.substring(0, 3)+'</b> '+orgnzPstnNm+'님'" @click="showProfile"></strong>
              <button type="button" class="cusSerach" @click="searchCstm">고객검색</button>
              <input type="text" placeholder="고객이름 또는 자녀이름으로 검색해주세요."
                  :value="custName" v-on:input="custName = $event.target.value" @keyup.enter="searchCstm">
              <!-- 2026.03.23 추천 찬스 추가 -->
              <button type="button" v-if="lowEpchk" @click="showRecoEvent" class="chance">추천찬스</button>
              <!-- // 2026.03.23 추천 찬스 추가 -->
              <button type="button" class="qr" @click="showQrcode">QR인증</button>
              <button type="button" class="atndn" :class="attendClss" @click="goSchedule()"><em>{{attendCnt}}</em>출석</button>
          </div>
          <!-- 2024.04.03 아침미팅 참석등록 -->
          <div class="mainWrap box">
              <div class="attend-box">
                  <p class="tit">아침미팅참석등록</p>
                  <div class="sign-box">
                  <button type="button" class="in allow-click" :class="{ active : (attendYn == '' || attendYn == undefined) }"  @click="attend()">
                      <p class="text">입장<span v-if="attendYn == '' || attendYn == undefined " class="icon-in-out"></span></p>
                      <span class="time">{{beacon.chltim}}</span>
                  </button>
                  <span class="separator"></span>
                  <!--2025.09.22 퇴장 중복으로 찍을수 있도록 처리 26.04 채명호 지각인원도 퇴장 찍히게-->
                  <button type="button" class="out allow-click"  :class="{ active: ['S', 'Y', 'N'].includes(attendYn) }" @click="beaconLeave()">
                      <p class="text">퇴장<span class="icon-in-out" v-if="['S', 'Y', 'N'].includes(attendYn)" ></span></p>
                      <span class="time">{{beacon.levtim}}</span>
                  </button>
                  </div>
              </div>
              <div class="attend-box" style="opacity: 0.5; border-top: 1px solid rgb(238, 238, 238); margin-top: 10px;">
                  <div class="sign-box">
                      <button type="button">
                          <span class="time">미팅 기준:
                              <span :style="{ color: attendYn == 'Y' ? 'green' : 'red', fontWeight: 'bold' }">
                                  {{ attendYn == 'Y' ? 'Y' : 'N' }}
                              </span>
                          </span>
                      </button>
                      <span class="separator"></span>
                      <button type="button">
                          <span class="time">정규교육 기준:
                              <span :style="{ color: isEduAvailable ? 'green' : 'red', fontWeight: 'bold' }">
                                  {{ isEduAvailable ? 'Y' : 'N' }}
                              </span>
                          </span>
                      </button>
                  </div>
              </div>
          </div>
            <!-- // 2024.04.03 아침미팅 참석등록 -->

          <swiper style="order:1" class="swiper swiperWrap" :options="swiperOption" @click="swiperClick($event,1)">
              <swiper-slide>
                  <div class="box mtvtn">
                      <h4>소스등록</h4>
                      <em>{{today.getFullYear()}}년 {{today.getMonth()+1}}월</em>
                      <p><i>목표달성</i><span><em>{{source.ratio}}</em>%</span></p>
                      <div class="graph">
                          <p><span :style="{width: source.ratio+'%'}"></span></p>
                          <i class="gold" :class="source.ratio == 100 ? 'chk' : ''">금</i>
                          <i class="silver" :class="source.ratio > 79 ? 'chk' : ''">은</i>
                          <i class="bronze" :class="source.ratio > 49 ? 'chk' : ''">동</i>
                          <em class="start">0건</em>
                          <em class="state" :style="{left: source.ratio+'%'}">{{source.attain}}건</em>
                          <em class="last">{{source.goal}}건</em>
                      </div>
                      <span :class="source.ratio == 100 ? 'gold' : source.ratio > 79 ? 'silver' : 'bronze'" v-if="source.ratio > 49">메달</span>
                      <figure><img src="../assets/images/img_character.svg" alt=""></figure>

                      <div class="medal" v-if="source.medalShow != null && source.medalShow != '' && !source.skip">
                          <div>
                              <dl>
                                  <dt>'{{medalNm[source.medalShow]}}메달 획득'</dt>
                                  <dd :class="source.medalShow">
                                      축하합니다.
                                  </dd>
                              </dl>
                              <button type="button" data-type="source">닫기</button>
                          </div>
                      </div>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="box mtvtn">
                      <h4>진단서비스</h4>
                      <em>{{today.getFullYear()}}년 {{today.getMonth()+1}}월</em>
                      <p><i>목표달성</i><span><em>{{coupon.ratio}}</em>%</span></p>
                      <div class="graph">
                          <p><span :style="{width: coupon.ratio+'%'}"></span></p>
                          <i class="gold" :class="coupon.ratio == 100 ? 'chk' : ''">금</i>
                          <i class="silver" :class="coupon.ratio > 79 ? 'chk' : ''">은</i>
                          <i class="bronze" :class="coupon.ratio > 49 ? 'chk' : ''">동</i>
                          <em class="start">0건</em>
                          <em class="state" :style="{left: coupon.ratio+'%'}">{{coupon.attain}}건</em>
                          <em class="last">{{coupon.goal}}건</em>
                      </div>
                      <span class="gold" :class="coupon.ratio == 100 ? 'gold' : coupon.ratio > 79 ? 'silver' : 'bronze'" v-if="coupon.ratio > 49">메달</span>
                      <figure><img src="../assets/images/img_character.svg" alt=""></figure>

                      <div class="medal" v-if="coupon.medalShow != null && coupon.medalShow != '' && !coupon.skip">
                          <div>
                              <dl>
                                  <dt>'{{medalNm[coupon.medalShow]}}메달 획득'</dt>
                                  <dd :class="coupon.medalShow">
                                      축하합니다.
                                  </dd>
                              </dl>
                              <button type="button" data-type="coupon">닫기</button>
                          </div>
                      </div>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="box mtvtn">
                      <h4>상담</h4>
                      <em>{{today.getFullYear()}}년 {{today.getMonth()+1}}월</em>
                      <p><i>목표달성</i><span><em>{{counsel.ratio}}</em>%</span></p>
                      <div class="graph">
                          <p><span :style="{width: counsel.ratio+'%'}"></span></p>
                          <i class="gold" :class="counsel.ratio == 100 ? 'chk' : ''">금</i>
                          <i class="silver" :class="counsel.ratio > 79 ? 'chk' : ''">은</i>
                          <i class="bronze" :class="counsel.ratio > 49 ? 'chk' : ''">동</i>
                          <em class="start">0건</em>
                          <em class="state" :style="{left: counsel.ratio+'%'}">{{counsel.attain}}건</em>
                          <em class="last">{{counsel.goal}}건</em>
                      </div>
                      <span :class="counsel.ratio == 100 ? 'gold' : counsel.ratio > 79 ? 'silver' : 'bronze'" v-if="counsel.ratio > 49">메달</span>
                      <figure><img src="../assets/images/img_character.svg" alt=""></figure>

                      <div class="medal" v-if="counsel.medalShow != null && counsel.medalShow != '' && !counsel.skip">
                          <div>
                              <dl>
                                  <dt>'{{medalNm[counsel.medalShow]}}메달 획득'</dt>
                                  <dd :class="counsel.medalShow">
                                      축하합니다.
                                  </dd>
                              </dl>
                              <button type="button" data-type="counsel">닫기</button>
                          </div>
                      </div>
                  </div>
              </swiper-slide>
              <div class="swiper-pagination swiperOption" slot="pagination"></div>
          </swiper>

          <div v-if="cardSort['HCD01']" :style="{order:cardSort['HCD01']}" class="box orgnz">
              <h4>당월 조직현황</h4>

              <div @click="goOrgList('list')">
                  <h6>재적</h6>
                  <span><em>{{orgnz.totcnt}}</em>명</span>
              </div>
              <div @click="goOrgList('meetY')">
                  <h6>미팅참석 *</h6>
                  <span><em>{{orgnz.meetY}}</em>명</span>
              </div>
              <div @click="todayMeetOrgList">
                  <h6>당일미팅</h6>
                  <span><em>{{orgnz.todayMeet}}</em>명</span>
              </div>
              <div @click="goOrgList('recruit')">
                  <h6>리크루팅</h6>
                  <span><em>{{orgnz.recruitCnt}}</em>명</span>
              </div>

              <ul>
                  <li @click="goOrgList('sil')">
                      <em>실활동</em>
                      <span><em>{{orgnz.silCnt}}</em>명</span>
                      <i>300만</i>
                  </li>
                  <li @click="goOrgList('sil1')">
                      <em>1차월</em>
                      <span><em>{{orgnz.silCnt1}}</em>명</span>
                      <i>300만</i>
                  </li>
                  <li @click="goOrgList('sil2')">
                      <em>2~3차월</em>
                      <span><em>{{orgnz.silCnt2}}</em>명</span>
                      <i>300만</i>
                  </li>
              </ul>

              <p>* 미팅참석 {{orgnz.meetBase}}일 이상</p>
          </div>

          <div v-if="cardSort['HCD02']" :style="{order:cardSort['HCD02']}" class="swiperWrap">
              <div class="box prfrm">
                  <h4>당월 실적</h4>
                  <div>
                      <span>목표실적</span>
                      <em><b>{{siljuck.goal | numFormat}}</b> 원</em>
                      <p><span :style="{width: siljuck.ratio+'%'}"></span></p>
                  </div>
                  <dl>
                      <dt>총 실적</dt>
                      <dd><em>{{siljuck.ratio}}%달성</em><i>{{siljuck.attain | numFormat}}</i> 원</dd>
                      <dt>신규 실적</dt>
                      <dd><i>{{siljuck.new | numFormat}}</i> 원</dd>
                  </dl>
                  <button v-if="$store.getters.akdrnk != '15'" type="button" data-type="orgList" @click="swiperClick($event,2)">{{ groupNm }}</button>

                  <div class="box actvt">
                      <h4>활동 현황</h4>
                      <ul>
                          <li>
                              <h6>소스</h6>
                              <span><em>{{activityByEp.custmCnt}}</em> 건</span>
                          </li>
                          <li>
                              <h6>진단검사</h6>
                              <span><em>{{activityByEp.coupnCnt}}</em> 건</span>
                          </li>
                          <li>
                              <h6>홈클래스</h6>
                              <span><em>{{activityByEp.homeclassCnt}}</em> 건</span>
                          </li>
                          <li>
                              <h6>만료예정</h6>
                              <span><em>{{activityByEp.expireCnt}}</em> 건</span>
                          </li>
                      </ul>
                      <!-- 2025.02.23 상담리포트 확인 추가 -->
                      <button type="button" class="reg"  @click="goCounselReport(selectVal)">상담리포트 확인</button>
                  </div>
              </div>
          </div>

          <div v-if="cardSort['HCD03']" :style="{order:cardSort['HCD03']}" class="box skd">
              <h4>내 일정 <em>{{today.getFullYear()}}.{{today.getMonth()+1 | addZero}}.{{today.getDate() | addZero}}({{week[today.getDay()]}})</em></h4>
              <ul>
                  <li v-for="(item,index) in mySchedule" :key="item.sqno" :class="item.cmplYn == 'Y' ? 'chk':''"  @click="updateCmplYn(index)">
                      <template v-if="item.allYn == 'Y'">
                          하루종일
                      </template>
                      <template v-else-if="item.sttHr == item.endHr">
                          {{ item.sttHr }}
                      </template>
                      <template v-else>
                          {{ item.sttHr }}~{{ item.endHr }}
                      </template>
                      <template v-if="item.scdlDivCd =='SSD07'">
                          <!-- 기타 일정 -->
                          {{ item.etcCntn | setLength }}
                      </template>
                      <template v-else-if="item.scdlDivCd =='SSD06'">
                          <!-- 동행 일정 - EP명 -->
                          {{ item.username2 }}님
                      </template>
                      <template v-else>
                          <!-- 그외 일정 - 고객명 -->
                          {{ item.custNm }}님
                      </template>

                      {{item.scdlDivNm}}
                  </li>
                  <li v-for="(item) in homeclassSchedule" :key="item.sqno">
                      <template>
                          {{ item.sbjcNm }}
                          {{ item.vstHr }}
                      </template>

                      {{item.memberNm}}
                  </li>
              </ul>
              <template v-if="mySchedule.length + homeclassSchedule.length < 1">등록된 일정이 없습니다.</template>
              <button type="button" class="more" @click="goSchedule">더보기</button>
          </div>

          <div v-if="cardSort['HCD04']" :style="{order:cardSort['HCD04']}" class="box crclm">
              <h4>내 교육과정</h4>
              <template v-if="myEducation.length > 0">
                  <swiper class="swiper swiperWrap" :options="swiperOption3">
                      <swiper-slide v-for="item in myEducation" :key="item.reqSeq">
                          <a href="javascript:void(0);" @click="goOtherSite(true,'studit','')">
                              <figure><img :src="thumbnailUrl+item.uuid" alt=""></figure>
                              <em>{{item.cateNm}}</em>
                              <strong>{{item.lecNm}}</strong>
                          </a>
                      </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination swiperOption3"></div>
              </template>
              <template v-else>진행중인 교육이 없습니다.</template>
              <button type="button" class="more" @click="goMyEdu">더보기</button>
          </div>

          <div v-if="cardSort['HCD05']" :style="{order:cardSort['HCD05']}" class="box allow-click">
              <h4>공지사항</h4>
              <ul class="notice">
                  <li v-for="(item,index) in noticeList" :key="index">
                      <a href="javascript:void(0);" @click="noticeDetail(index)">
                          <em :class="item.importance === '1' ? 'impt' : ''">{{item.importance === '1' ? '긴급' : '일반'}}</em>
                          {{item.title}}
                      </a>
                  </li>
              </ul>
              <button type="button" class="more" @click="goNotice">더보기</button>
          </div>

          <div v-if="cardSort['HCD06']" :style="{order:cardSort['HCD06']}" class="box family allow-click">
              <h4>바로가기</h4>
              <ul>
                  <li><a href="javascript:void(0)" @click="goOtherSite(true,'kss','')">
                      <figure><img src="../assets/images/img_family_01.svg" alt="KSS"></figure>
                      <span></span>
                  </a></li>
                  <li><a href="javascript:void(0)" @click="goOtherSite(true,'studit','')">
                      <figure><img src="../assets/images/img_family_02.svg" alt="STUDIT"></figure>
                  </a></li>
                  <li><a href="javascript:void(0)" @click="goOtherSite(false,null,'https://www.kwmembers.com/main/MainView.do?retCode=0000')">
                      <figure><img src="../assets/images/img_family_03.svg" alt="K멤버스"></figure>
                      <span></span>
                  </a></li>
                  <li v-if="isEventPeriod()"><a href="javascript:void(0)" @click="goOtherSite(true,'cubig','')">
                      <figure><img src="../assets/images/img_family_04.svg" alt="Cubig"></figure>
                      <span></span>
                  </a></li>
                  <li><a href="javascript:void(0)" @click="goOtherSite(false,null,'http://www.kyowonedu.com')">
                      <figure><img src="../assets/images/img_family_05.svg" alt="교원EDU"></figure>
                      <span></span>
                  </a></li>
                  <li><a href="javascript:void(0)" @click="goOtherSite(false,null,'http://www.eduhimom.co.kr/')">
                      <figure><img src="../assets/images/img_family_06.svg" alt="Himom"></figure>
                      <span></span>
                  </a></li>
                  <li><a href="javascript:void(0)" @click="goOtherSite(false,null,'http://pf.kakao.com/_xaBspV/chat')">
                      <figure><img src="../assets/images/img_family_07.svg" alt="고객지원"></figure>
                      <span></span>
                  </a></li>
                  <li v-if=false><a href="javascript:void(0)" @click="goOtherSite(false,null,'http://cubig.kyowon.co.kr/interface/requestGdEvent202203.page')">
                      <figure><img src="../assets/images/event/img_event_01.svg" alt="이벤트"></figure>
                      <span></span>
                  </a></li>
              </ul>
          </div>
          <!-- 2026.09.18 챗봇 버튼-->
          <div class="fltMn">
              <button type="button" class="chatbot allow-click" @click="chatbot"></button>
          </div>
          <!--// 2026.09.18 챗봇 버튼-->
      </section>
      <base-footer></base-footer>

      <div class="dim" v-if="isGroup">
          <div class="botWrap selectBox">
              <h6>조직 선택</h6>
              <ul>
                  <li v-for="(option, index) of options" :key="index" @click="groupSelect(option)">
                      <button type="button" :class="option.value == groupVal ? 'current' : ''">{{ option.name }}</button>
                  </li>
              </ul>
              <button type="button" class="close" @click="groupView">닫기</button>
          </div>
      </div>
      <div class="dim" v-if="meetOrgList">
          <div class="botWrap selectBox">
              <h6>조직 선택</h6>
              <ul>
                  <li v-for="(option, index) of todayMeetList" :key="index" @click="orgSelect(option)">
                      <button type="button" >{{option.akdnam}} {{option.gubunNm}}</button>
                  </li>
              </ul>
              <button type="button" class="close" @click="todayMeetOrgList">닫기</button>
          </div>
      </div>
  </div>
</div>
</template>
<script>
var parser = new DOMParser();

export default {
  name: "Main",
  components: {
  },
  data() {
    return {
        swiperOption: {
          loop : true,
          pagination: {
            el: '.swiperOption'
          },
        },
        swiperOption2: {
          loop : true,
           pagination: {
             el: '.swiperOption2'
           },
        },
        swiperOption3: {
           slidesPerGroup : 2,
           slidesPerView : 2,
           spaceBetween : 10,
           pagination: {
             el: '.swiperOption3'
           },
        },
        userName: this.$utils.ui.getUserName(), // 이름
        orgnzPstnNm: this.$utils.ui.getOrgnzPstnNm(), // 직급
        orgnzPstnGradeNm: this.$utils.ui.getOrgnzPstnGradeNm(), // 직급_등급??
        orgnzPstn: this.$store.state.session.orgnzPstn, // 직급
        userId : this.$store.getters.userId,  //로그인사번
        loginGbn : this.$store.getters.loginGbn, //로그인구분
        custName: '',   //고객 검색어
        options:[       //조직원 리스트
            { name: '조직전체', value: 'all'}
        ],
        groupNm: '조직전체',
        groupVal: 'all',
        groupTm : false,
        isGroup: false,
        today : new Date(),
        week : ['일','월','화','수','목','금','토'],
        medalNm : {'gold':'금','silver':'은','bronze':'동'},
        attendClss: 'chk', // 출석여부
        attendCnt: '0', // 출석일수
        attendYn: '',
        attendCheck: true,
        srvySqno: '',   // 설문지
        cardSort: {'HCD01':6,'HCD02':2,'HCD03':3,'HCD04':4,'HCD05':5,'HCD06':6},    //카드 순서
        source:{    // 동기부여-소스
            goal:0,
            attain:0,
            ratio:0,
        },
        coupon:{	// 동기부여-진단
            goal:0,
            attain:0,
            ratio:0,
        },
        counsel:{	// 동기부여-상담
            goal:0,
            attain:0,
            ratio:0,
        },
        orgnz:{},	// 당월 조직 현황
        siljuck:{	// 당월 실적
            goal:0,
            attain:0,
            new:0,
            ratio:0
        },
        activity:{},	// 당월 활동 현황
        mySchedule:[],	// 일정
        homeclassSchedule:[],	// 홈클래스 일정
        myEducation:[],	// 교육과정
        thumbnailUrl:'http://studit.kyowon.co.kr/upload/data2/doclink/',
        noticeList:[],  //공지사항
        meetOrgList:false,  //당일미팅조직원 노출여부
        todayMeetList:[],   //당일미팅조직원 리스트
        activityByEp: {},
        beacon: {
            chltim: '--:--:--',
            levtim: '--:--:--'
        },
        selectVal: '', // 지국장일때 선택한 사번(예: "1708778")이 저장됩니다.
        lowEpchk : false
    };
  },
  watch: {
    '$store.state.ui.child': function() {
      var that = this;
      var childName = this.$store.state.ui.child.name;

      if(childName == 'popup') {
        var popup = this.$store.state.ui.child.data;
        this.$store.commit("SET_POP", popup);
      } else if(childName == 'beacon') {
        // alert("TODO: 모닝체크 완료 됨, 이벤트 처리 해야 함");
        this.storeMnCheck();    // 모닝체크 완료 스토어 저장

        this.$api.dashboard
        .getMorningCheck({})
        .then(function (data) {
            if(data){
                // if(data.attendYn == "Y" || data.attendYn == "N")
                //     that.attendClss = 'chk';
                // that.attendCnt = data.attendCnt + (data.attendYn == "Y" ? 1 : 0);
                that.attendYn = data.attendYn

                that.beacon.chltim = data.chltim;
                that.beacon.levtim = data.levtim;
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
      } else if(childName == 'beacon-leave') {
        // alert("TODO: 모닝체크 완료 됨, 이벤트 처리 해야 함");
        this.$api.dashboard
        .getMorningCheck({})
        .then(function (data) {
            if(data){
                // if(data.attendYn == "Y" || data.attendYn == "N")
                //     that.attendClss = 'chk';
                that.attendYn = data.attendYn
                that.attendCnt = data.attendCnt + (data.attendYn == "Y" ? 1 : 0);
                that.beacon.chltim = data.chltim;
                that.beacon.levtim = data.levtim;
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
      } else if(childName == 'main-survey-close'){
        //설문창 닫혔을 때 재조회
        this.$api.dashboard.base({})
        .then(function (data) {
            if(data.userInfo){
                that.srvySqno = data.userInfo.srvySqno;
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
      }
    },
    custName(newVal, oldVal){
        var len = newVal.length;
        if(len > 10)
            this.custName = oldVal;
    }
  },
computed: {
    // 정규교육 입장/퇴장 가능 여부 계산
    isEduAvailable() {
      // beacon 데이터가 없는 경우 방어 로직
      if (!this.beacon) return false;

      //console.log('isEduAvailable 계산 중...', this.beacon);

      const ctimStr = this.beacon.chltim || "";
      const ltimStr = this.beacon.levtim || "";

      // 시간 문자열에서 숫자가 아닌 문자(:, -, 공백 등)를 모두 제거하고 숫자로 변환하는 함수
      const parseTime = (timeStr) => {
        const cleanStr = timeStr.replace(/[^0-9]/g, '');
        // 숫자가 아예 없다면 ("--:--:--" 같은 경우) null 반환
        return cleanStr === '' ? null : Number(cleanStr);
      };

      const ctim = parseTime(ctimStr); // "08:02:55" -> 80255
      const ltim = parseTime(ltimStr); // "--:--:--" -> null

      // 정규교육: 10:20:59 이하 이거나 11:30:00 이상
      // null이 아닌 유효한 숫자일 때만 비교하도록 처리
      const isCtimValid = ctim !== null && ctim <= 102059;
      const isLtimValid = ltim !== null && ltim >= 113000;

      return isCtimValid && isLtimValid;
    },
  },
  methods: {
    isShowPopup(pop) {
      var closedPoplist = this.$store.getters.pops;
    //   console.log('App.vue', 'showPopup', closedPoplist, pop);

      var sqno = pop.sqno;
      var ppupTyp = pop.ppupTyp; // 0:오늘하루열지않음, 1:다시열지않음
      var isShow = true;
      for(var i=0;i<closedPoplist.length;i++) {
        var closedPop = closedPoplist[i];
        //  {sqno:0, ppupTyp:'0', dt:'YYYYMMDD'}
        if(closedPop.sqno != sqno) {
          continue;
        }

        if(ppupTyp == '0') {
          var closedDt = closedPop.dt;
          var yyyymmdd = this.$utils.date.yyyymmdd();
          if(closedDt == yyyymmdd) {
            isShow = false;
          }
        } else {
          isShow = false;
        }
      }
      return isShow;
    },
    isEventPeriod() {
      var today = this.$utils.date.yyyyMMddhh();
      if(today >= 2022030310 && today <= 2022053117) {
          return true;
      }
      return false;
    },
    showPopup(pop) {
      var isShow = this.isShowPopup(pop);
    //   console.log('App.vue showPopup', 'isShow', isShow);
      if(isShow) {
        this.$utils.nativeIf.outbound.newPage('/popup/' + pop.sqno);
      }
    },
    showProfile(){
        if(this.userId)
            this.$utils.nativeIf.outbound.outlink("http://morder.kyowon.co.kr/ptt/mcard/"+this.userId); //외부로 kss명함 띄우기
            // this.$utils.nativeIf.outbound.newPage('/dashboard/profile/'+this.userId);    //내부 명함 화면 -> 삭제 예정
    },
    openSurv : function(){
        // this.$router.push('/mypage/SurveyView?srvySqno='+this.srvySqno);  // 현재창 에서 넘어가기
        // this.$utils.nativeIf.outbound.newPage("/mypage/SurveyView?srvySqno="+this.srvySqno+"&from=main")  //새창 띄우기
        this.$router.push({ name: "survey-view", query: { srvySqno: this.srvySqno}}).catch(function() {});
    },
    attend : function(){
        if(this.attendCheck && (this.attendYn == '' || this.attendYn == undefined)){
            this.attendCheck = false;
            var that = this;

            // var strLocation = "";
            // try {
            //     if(this.$store.state.ui.child.name == 'native-location') {
            //         strLocation = btoa(unescape(encodeURIComponent(JSON.stringify(this.$store.state.ui.child.data))));
            //     }
            // } catch(err) {
            //     alert(err);
            //     console.log(err)
            // }

            var param1 = {
				// location: strLocation,
			};

            this.$api.beacon.getMacAddress(param1)
            .then(function(data) {
                var list = [];
                for(var item of data) {
                    list.push(item.macAddress);
                }

                var param = {
                    type: "M",
                    list: list
                }

                var jsonString = JSON.stringify(param);
                that.$utils.nativeIf.outbound.userMnChk(jsonString);

                setTimeout(function(){that.attendCheck = true;}, 2000);
            })
            .catch(function(error) {
                that.attendCheck = true;
                alert(error.rtMsg);
            });
        }
    },
    beaconLeave : function(){
        // 2025.09.22 정상 출근을 한뒤로도 계속 퇴장을 찍을수 있도록 변경
        if(this.attendCheck && ['S', 'Y', 'N'].includes(this.attendYn)) {
            this.attendCheck = false;
            var that = this;

            this.$api.beacon.getMacAddress({})
            .then(function(data) {
                var list = [];
                for(var item of data) {
                    list.push(item.macAddress);
                }

                var param = {
                    type: "LM",
                    list: list
                }

                var jsonString = JSON.stringify(param);
                that.$utils.nativeIf.outbound.beaconLeaveChk(jsonString);

                setTimeout(function(){that.attendCheck = true;}, 2000);
            })
            .catch(function(error) {
                that.attendCheck = true;
                alert(error.rtMsg);
            });
        }
    },
    searchCstm : function(){
        var parent = {
            name: 'my-cstmr-list-param',
            data: {searchCustNm : this.custName}
        };
        this.$store.commit("SET_UI_PARENT", parent);
        this.$router.push('/myCstmr/myCstmrList');
    },
    groupSelect : function(option){
        if(this.groupTm ){
            this.groupNm = option.name
            this.groupVal = option.value
            this.isGroup = !this.isGroup
            this.selectVal = option.value
            this.getSiljuck(option.value);
        }
    },
    groupView : function() {
        this.isGroup = !this.isGroup
    },
    getSiljuck : function(val){
        // console.log("실적조회 : "+val)
        var type = "self";
        var targetId = val;
        if('all' == val){
            type = 'all'
            targetId = ""
        }

        var param = {
            type : type,
            targetId : targetId
        }

        var that = this;
        this.$api.dashboard
        .siljuck(param)
        .then(function (data) {
            // console.log("  실적조회",data);
            if(data){
                that.siljuck.attain = data.totamt;
                that.siljuck.goal = data.goalAmt * 10000;
                that.siljuck.new = data.newAmt;

                var ratio = 0;
                if(data.goalAmt && data.goalAmt > 0){
                    ratio = Math.floor(data.totamt / (data.goalAmt * 10000) * 100)
                    if( ratio > 100 )
                        ratio = 100;
                }

                that.siljuck.ratio = ratio;
                that.activityByEp = data.activity;
            }else{
                that.siljuck.attain = 0;
                that.siljuck.goal = 0;
                that.siljuck.new = 0;
                that.siljuck.ratio = 0;
                that.activityByEp = {
                    custmCnt: 0,
                    coupnCnt: 0,
                    bkcareCnt: 0,
                    homeclassCnt: 0,
                    expireCnt: 0,
                };
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    goSchedule : function(){
        this.$router.push('/mySchedule/myScheduleList').catch(function() {}).then((() =>window.scrollTo(0,0) ));
    },
    goMyEdu : function(){
        this.$router.push('/mypage/myEduInfor').catch(function() {}).then((() =>window.scrollTo(0,0) ));
    },
    goCounselReport : function(){
      const searchUserId = this.groupVal;
      let targetUrl = '/mypage/myCounselReport';

      // empId에 값이 존재하고(비어있지 않고), 그 값이 'all'이 아닐 때만 파라미터를 붙여줍니다.
      if (searchUserId && searchUserId !== 'all') {
        targetUrl += `?searchUserId=${searchUserId}`;
      }

      // 최종 URL로 페이지 이동
      // (선택된 값이 없거나 'all'이면 기본 주소 그대로 이동합니다)
      this.$utils.nativeIf.outbound.newPage(targetUrl);
    },
    htmlParser : function (text) {
        return parser.parseFromString(text, "text/html").body.innerText;
    },
    goNotice : function(){
        this.$router.push('/notice');
    },
    noticeDetail : function(index){
        var item = this.noticeList[index];
        var itemId = item.itemId;
        //this.$router.push('/notice/NoticeDetail?itemId='+itemId);  // 현재창 에서 넘어가기
        this.$utils.nativeIf.outbound.newPage('/notice/detail/?itemId='+itemId)  //새창 띄우기
    },
    updateCmplYn: function (index){ // 일정 완료/미완료 처리        // MyScheduleList.vue 참고
        if("Y" == this.mySchedule[index].cmplYn){
            if(!confirm("선택하신 완료 일정을 미완료 상태로 변경하시겠습니까?")){
                return;
            }else{
                this.mySchedule[index].cmplYn = "N";
            }
        }
        else{
            this.mySchedule[index].cmplYn = "Y";
        }

        var that = this;
        var params = {cudType:"CMP",sqno:this.mySchedule[index].sqno,cmplYn:this.mySchedule[index].cmplYn};

        this.$api.myschedule.saveMyschedule(params)
        .then(function() {
            that.$api.dashboard.base({})
            .then(function (data) {
                if(data.progressInfo){
                    //소스등록
                    that.source = that.setGraphData(data.progressInfo.srcGoal, data.progressInfo.custmCnt);
                    that.source.medalShow = that.showMedal('source', that.source.ratio);
                    //진단검사
                    that.coupon = that.setGraphData(data.progressInfo.dgnssrvcGoal, data.progressInfo.coupnCnt);
                    that.coupon.medalShow = that.showMedal('coupon', that.coupon.ratio);
                    //상담
                    that.counsel = that.setGraphData(data.progressInfo.consGoal, data.progressInfo.counselCnt);
                    that.counsel.medalShow = that.showMedal('counsel', that.counsel.ratio);
                }
            })
            .catch(function (error) {
                alert(error.rtMsg);
            });
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    },
    goOrgList : function(type){
        this.$router.push({ name: "orgnz-list", params: { option: type}}).catch(function() {});
    },
    todayMeetOrgList : function(){
        if(this.todayMeetList.length > 0) {
            this.meetOrgList = !this.meetOrgList
        }
    },
    orgSelect : function(option){
        this.todayMeetOrgList();
        this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView?targetId="+option.akdcde)
    },
    storeMnCheck : function(){
        var date = this.today.getFullYear() +"/"+ (this.today.getMonth()+1) +"/"+ this.today.getDate()
        var mnCheck = {
            name : this.userName,
            dt : date
        };
        this.$store.commit("SET_MN_CHECK", mnCheck); //store 저장
    },
    showQrcode : function(){
        //QR인증 페이지로 이동
        this.$router.push('/eduKakaoSync').catch(function() {}).then((() =>window.scrollTo(0,0) ));
    },
    showRecoEvent : function(){
        //QR인증 페이지로 이동
        this.$router.push('/showRecoEvent').catch(function() {}).then((() =>window.scrollTo(0,0) ));
    },
    fnHCD01(){
        var that = this;
        this.$api.dashboard
        .organization({})
        .then(function (data) {
            // console.log("  조직현황",data);
            if(data){
                that.orgnz = data
                if(data.meetOrgList)
					that.todayMeetList = data.meetOrgList	//오늘 출석한 인원 리스트
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    fnHCD02(){
        var that = this;
        if(this.$store.getters.akdrnk != '15'){
            if(this.$store.getters.akdrnk == '10'){
                this.options = [{ name: '지구전체', value: 'all'}]
            }

            //조직원 정보 가져오기
            var myIdx = 0;
            this.$api.dashboard
            .orglist({})
            .then(function (data) {
                // console.log("  당월현황",data);
                if(data){
                    for(var idx=0;idx<data.length; idx++){
                        var nm = data[idx].akdnam;
                        if(data[idx].gubunNm){
                            nm += ' ' + data[idx].gubunNm
                        }
                        that.options.push({name: nm, value: data[idx].akdcde});
                        if(data[idx].isMe == 'Y'){
                            myIdx = idx+1;
                        }
                    }

                    if(that.$store.getters.orgnzPstn == 'COG01'){
                        //지국장 => 조직 전체
                        that.getSiljuck('all');
                    }else{
                        //지구장 => 본인
                        that.groupNm = that.options[myIdx].name
                        that.groupVal = that.options[myIdx].value
                        that.getSiljuck();
                    }
                }
            }).catch(function (error) {
                // console.log(error);
                alert(error.rtMsg);
            });
        }else{
            this.getSiljuck();
        }

        //활동 현황 조회
        this.$api.dashboard
        .activity({})
        .then(function (data) {
             console.log("  활동 현황",data);
            if(data){
                that.activity = data;
            }
        }).catch(function (error) {
            alert(error.rtMsg);
        });
    },
    fnHCD03(){
        //오늘 내 일정 조회
        var that = this;
        this.$api.dashboard
        .schedule({offet:0, size:3})
        .then(function (data) {
            // console.log("  일정",data);
            if(data){
                that.mySchedule = data.slice(0,3)
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
        //홈클래스 일정 조회
        if (that.$store.getters.orgnzPstn !== 'COG01') {
            this.$api.dashboard
                .homeclassschedule({ offset: 0, size: 3 })
                .then((data) => {
                    console.log("일정", data);
                    if (data) {
                        this.homeclassSchedule = data.slice(0, 3);
                    }
                })
                .catch((error) => {
                    alert(error.rtMsg);
                });
        }
    },
    fnHCD04(){
        var that = this;
        this.$api.dashboard
        .education({offet:0, size:6})
        .then(function (data) {
            // console.log("  내교육",data);
            if(data){
                that.myEducation = data
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    fnHCD05(){
        //공지사항 4개 조회
        var that = this;
        var parameters = {
            offset: 0,
            size: 4
        };
        this.$api.notice
        .list(parameters)
        .then(function(data) {
            // console.log("     공지사항",data)
            that.noticeList = data.list
        }).catch(function(error) {
            alert(error.rtMsg);
            // console.log(error);
        });
    },
    goOtherSite(ssoYn, type, url){
        if(ssoYn){
            if(type == 'kss'){
                this.$utils.external.kss(url);
            }else {
                if(type == 'studit'){
                    // 인증서 이슈로 URL 직접 호출
                    //this.$utils.external.cubig("http://studit.kyowon.co.kr/cyber.do?method=openStuditEduCourseNewMob&siteSection=studit&org_cls=ED&pageDiv=MYPAGE&moveMypageWatch=N");
                    this.$utils.nativeIf.outbound.outlink("https://studit.kyowon.co.kr/studit/index.page")
                }else if(type == 'cubig'){
                    // 인증서 이슈로 URL 직접 호출
                    this.$utils.external.cubig("http://cubigm.kyowon.co.kr/AuthMob.do?method=mainEdu&siteSection=cubig_m");
                }else{
                    alert("잘못된 요청입니다.")
                    return false;
                }
            }
        }else{
            this.$utils.nativeIf.outbound.outlink(url)
        }

    },
    setGraphData(goal, attain){     //동기부여 데이터 set
        var returnMap = {};
        var ratio = 0;
        if(goal > 0){
            ratio = attain/goal*100;
            ratio = ratio > 100 ? 100 : Math.floor(ratio);
        }
        returnMap.goal=goal;
        returnMap.attain=attain;
        returnMap.ratio=ratio;
        returnMap.skip = false;
        return returnMap;
    },
    showMedal(name, ratio){     //동기부여 메달 달성 표시여부
        var type = null;

        if(ratio == 100){
            type = 'gold'
        }else if(ratio > 79){
            type = 'silver'
        }else if(ratio > 49){
            type = 'bronze'
        }else{
            return type;
        }

        var checkedMedal = this.$store.getters.medal;
        var yyyymm = this.today.getFullYear()+''+this.$options.filters.addZero(this.today.getMonth()+1)

        for(var i=0;i<checkedMedal.length;i++) {
            var item = checkedMedal[i]; //  {name:'동기부여구분값', type:'메달구분값', dt:'YYYYMM'}
            if(item.name == name && item.type == type && item.dt == yyyymm){    //동기구분/메달구분/당월 확인한적있는경우=>표시안함.
                type = null;
                break;
            }
        }
        return type;
    },
    swiperClick(e,index) {	//슬라이드 클릭 시
        var name = e.target.getAttribute('data-type')
        var that = this
        if(name){
            if(index == 1){         //동기부여
                this.checkMedal(name)
            }else if (index == 2){  //당월실적
                this.isGroup = false
                this.groupView();
                this.groupTm = false

                setTimeout(function(){that.groupTm = true;},100)
            }
        }
    },
    checkMedal(name){     //동기부여 메달 달성 확인체크(당월에는 다시 안보여줌.)
        var yyyymm = this.today.getFullYear()+''+this.$options.filters.addZero(this.today.getMonth()+1)

        var medal = {
            name : name,
            type : this[name].medalShow,
            dt : yyyymm
        };

        this[name].skip = true;     //달성 확인 div 닫기

        this.$store.commit("SET_MEDAL", medal); //store 저장
    },
    getProgress(){
        var that = this;
        this.$api.dashboard
        .progress({})
        .then(function (data) {
            if(data){
                //소스등록
                that.source = that.setGraphData(data.srcGoal, data.custmCnt);
                that.source.medalShow = that.showMedal('source', that.source.ratio);
                //진단검사
                that.coupon = that.setGraphData(data.dgnssrvcGoal, data.coupnCnt);
                that.coupon.medalShow = that.showMedal('coupon', that.coupon.ratio);
                //상담
                that.counsel = that.setGraphData(data.consGoal, data.counselCnt);
                that.counsel.medalShow = that.showMedal('counsel', that.counsel.ratio);
            }
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    dashboard() {
        var mnCheck = this.$store.getters.mnCheck;
        var date = this.today.getFullYear() + (this.today.getMonth()+1) + this.today.getDate()
        //if(mnCheck.name != this.userName || mnCheck.dt != date){
        //    // 1. 모닝 체크
        //    window.app.$root.$utils.nativeIf.inbound.callMnChk();
        //}
        // 1. 푸시토큰 저장
         this.$api.app.setPushToken({});

        // 2. 대시보드
        var that = this;
        this.$api.dashboard
        .base({})
        .then(function (data) {
            // console.log("  대시보드 기본",data);
            if(data.userInfo){
                // that.attendClss = 'chk'
                that.attendYn = data.userInfo.attendYn

                that.beacon.chltim = data.userInfo.chltim;
                that.beacon.levtim = data.userInfo.levtim;

                if(data.userInfo.attendYn == "Y" || data.userInfo.attendYn == "N"){
                    // that.attendClss = 'chk';
                    if(mnCheck.name != that.userName || mnCheck.dt != date){
                        that.storeMnCheck();    // 앱 외에 다른 방식으로 체크했을경우
                    }
                }
                that.attendCnt = data.userInfo.attendCnt + (data.userInfo.attendYn == "Y" ? 1 : 0);
                that.srvySqno = data.userInfo.srvySqno;
                that.userId = data.userInfo.akdcde;
            }
            that.lowEpchk = data.lowEpchk; //EP 체크 추가
            if(data.cardList){
                var newSort = {};
                var list = data.cardList;
                for(var idx in list){
                    newSort[list[idx].cardCd] = list[idx].expoSqnc;
                    if(list[idx].cardCd != 'HCD06') {
                        console.log('aaaaaaaaaaaaaaaa', 'fn'+list[idx].cardCd);
                        that['fn'+list[idx].cardCd]();
                    }
                }
                that.cardSort = newSort;
            }
            that.getProgress();
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    // 고객 정보 session 현행화
    refreshUserInfo() {
      const that = this;
      this.$api.dashboard
          .getUserInfo()
          .then(function (res) {
              // 고객 정보가 변경된 경우 store 갱신 및 새로고침 하여 정보 갱신
              if(that.loginGbn == 'AK'){
                if (that.isDirtySession(res)) {
                  alert("사용자 정보가 변경되어 세션을 종료합니다.");
                  that.$store.dispatch("clearUser");
                  that.$utils.nativeIf.outbound.sessionExpired();

                //   that.$store.commit("SET_USER", res);
                //   that.$utils.nativeIf.outbound.setAppDB("authToken", res.authToken);
                //   location.reload();
              }
            }
          })
          .catch(function (error) {
              alert(error.rtMsg);
              that.$store.dispatch("clearUser");
              that.$utils.nativeIf.outbound.sessionExpired();
          });
    },
    // 세션 변경 여부
    isDirtySession(res) {
        if (this.$store.getters.userName === res.userName
            && this.$store.getters.orgnzPstn === res.orgnzPstn
            && this.$store.getters.cntrCd === res.cntrCd
            && this.$store.getters.brncCd === res.brncCd
            && this.$store.getters.akdrnk === res.akdrnk
            && this.$store.getters.akdmi3 === res.akdmi3
        ) {
            return false;
        }

        return true;
    },
    openQrScaner: function() {
        var callback = "window.app.$root.$utils.nativeIf.inbound.eduAtndnCheck";
        this.$utils.nativeIf.outbound.openQrScaner(callback);
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
    checkLoginGbn(event) {
      if (this.loginGbn === 'IS') {
          // 1. 허용된 클릭인지 확인 (.allow-click)
          const isAllowed = event.target.closest('.allow-click');
          if (isAllowed) return; // 허용된 요소면 통과 (정상 @click 실행)

          // 2. 실제로 "클릭 가능한 요소(버튼, a태그, strong태그 등)"를 누른 건지 확인
          // alert이 떠야 하는 대상을 closest()로 지정합니다.
          const isClickableableElement = event.target.closest('button, a, strong, .btn, [role="button"]');

          // 클릭 가능한 요소를 눌렀을 때만 차단 및 alert 띄움
          if (isClickableableElement) {
            event.preventDefault(); //href 차단
            event.stopPropagation(); // 자식 @click 차단
            alert('해당기능은 추후 업데이트 예정입니다.');
          }
      }
    },
  },
  mounted() {
    this.refreshUserInfo();
  },
  created: function() {
    // this.$utils.nativeIf.outbound.getLocation();

    // console.log ("CREATE : "+this.$store.state.session.userId);
    var that = this;
    this.$api.popup
      .list({})
      .then(function (list) {
        // console.log(
        //   "Main.vue <api.popup.list.response>",
        //   list
        // );

        if(Array.isArray(list)) {
            for(var i=0;i<list.length;i++) {
                var pop = list[i];
                that.showPopup(pop);
            }
        }
        that.dashboard();
      })
      .catch(function (error) {
        alert(error.rtMsg);
        that.dashboard();
      });
  },
  filters:{
    numFormat:function(num){
        if(!num || num==0) return 0;

        var n = num+'';
        var reg = /(^[+-]?\d+)(\d{3})/;

        while (reg.test(n))
            n = n.replace(reg,'$1'+','+'$2');

        return n;
	},
    addZero:function(num){
        if(!num || num==0) return "00";

        if(num > 10) return num;
        else return "0"+num;
    },
    setLength:function(str){
        if(!str || str.length < 8){
            return str;
        }else{
            return str.substr(0,8).trim()+"..."
        }
    }
  },
  beforeDestroy() {
    // 컴포넌트가 사라질 때 백그라운드에서 타이머가 계속 도는 것을 방지합니다.
    // (만약 Vue 3 버전을 사용 중이시라면 beforeDestroy() 대신 unmounted() 를 사용하세요)
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style>
    .swiper-pagination-bullets .swiper-pagination-bullet {margin: 0 2px !important;}
    .swiper-pagination-bullet {width: 6px !important;height: 6px !important;border-radius: 3px !important;}
    .swiper-pagination-bullet-active {width: 10px !important;background-color: rgb(52,41,109) !important;}
    .swiperOption3 {left: 50%;bottom: 12px;transform: translateX(-50%) !important;}
</style>
